"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _BaseMixpanelAnalytics = _interopRequireDefault(require("../common/BaseMixpanelAnalytics"));

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AmplitudeAnalytics = /*#__PURE__*/function (_BaseMixpanelAnalytic) {
  (0, _inherits2["default"])(AmplitudeAnalytics, _BaseMixpanelAnalytic);

  var _super = _createSuper(AmplitudeAnalytics);

  function AmplitudeAnalytics() {
    (0, _classCallCheck2["default"])(this, AmplitudeAnalytics);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(AmplitudeAnalytics, [{
    key: "createClient",
    value: function createClient(analyticsId) {
      _mixpanelBrowser["default"].init(analyticsId, {
        track_pageview: false,
        batch_requests: true,
        cross_site_cookie: true
      });

      return _mixpanelBrowser["default"];
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId, isUserCreated) {
      if (!userId) {
        this.log("Mixpanel: setUserId no userId, skipping");
        return;
      }

      if (isUserCreated) {
        this.log("Mixpanel: setUserId set alias = ", userId);

        _mixpanelBrowser["default"].alias(userId);
      } else {
        this.log("Mixpanel: setUserId identify = ", userId);

        _mixpanelBrowser["default"].identify(userId);
      }
    }
  }, {
    key: "trackEvent",
    value: function () {
      var _trackEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(eventName, props) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.log("Mixpanel trackEvent: eventName = ", eventName, ", props = ", props);
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  _mixpanelBrowser["default"].track(eventName, props, function () {
                    // this.log("Mixpanel trackEvent: ", ...args)
                    resolve();
                  });
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function trackEvent(_x, _x2) {
        return _trackEvent.apply(this, arguments);
      }

      return trackEvent;
    }()
  }]);
  return AmplitudeAnalytics;
}(_BaseMixpanelAnalytics["default"]);

exports["default"] = AmplitudeAnalytics;